import React, { Component } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { UserProvider } from "./contexts/UserContext";
import { WebSocketProvider } from "./contexts/WebSocketContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Main from "./pages/Main";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CancelPage from "./pages/Cancel";
import TeamRegistrationForm from "./components/TeamRegistration";
import TimeframeManagement from "./components/TimeframeManagement";
import PricingTiers from "./components/PricingTiers";
import ServicePricing from "./components/ServicePricing";
import DiscountCodes from "./components/DiscountCodes";
import BusinessHours from "./components/BusinessHours";
import ServiceManagement from "./components/ServiceManagement";
import BookingPage from "./pages/Booking";
import Upcoming from "./pages/Upcoming";
import BookNow from "./pages/BookNow";
import SearchEvents from "./pages/SearchEvents";
import "@fortawesome/fontawesome-free/css/all.min.css";
import OrganizationManagement from "./components/OrganizationManagement";
import BusinessClosures from "./components/BusinessClosures";
import BusinessHourExceptions from "./components/BusinessHourExceptions";
import LeagueManagement from "./components/league/LeagueManagement";
import SwitchBookingPage from "./pages/Switch";
import LeagueSchedule from "./pages/LeagueSchedule";
import LeagueScores from "./pages/LeagueScores";
import LeagueTeamScore from "./pages/LeagueTeamScore";
import LeagueRegistration from "./pages/LeagueRegistration";
import UpcomingSchedule from "./pages/UpcomingSchedule";
import OtpLoginPage from "./pages/OtpLoginPage";
import LeaguePlayersPrint from "./pages/LeaguePayments";
import LeaguePayments from "./pages/LeaguePayments";
import LeagueScoresAdmin from "./pages/LeagueScoresAdmin";

class App extends Component {
    render() {
        return (
            <UserProvider>
                <BrowserRouter>
                    <Routes>
                        <Route element={<ProtectedRoute />}>
                            <Route path="/main" element={<WebSocketProvider><Main /></WebSocketProvider>} />
                            <Route path="/upcoming" element={<WebSocketProvider><Upcoming /></WebSocketProvider>} />
                            <Route path="/booknow" element={<WebSocketProvider><BookNow /></WebSocketProvider>} />
                            <Route path="/search" element={<WebSocketProvider><SearchEvents /></WebSocketProvider>} />
                            <Route
                                path="/organization/"
                                element={<OrganizationManagement />}
                            />
                            <Route
                                path="/timeframes/"
                                element={<TimeframeManagement />}
                            />
                            <Route
                                path="/pricing-tiers/"
                                element={<PricingTiers />}
                            />
                            <Route
                                path="/service-pricing/"
                                element={<ServicePricing />}
                            />
                            <Route
                                path="/discount-codes/"
                                element={<DiscountCodes />}
                            />
                            <Route
                                path="/business-hours/"
                                element={<BusinessHours />}
                            />
                            <Route
                                path="/business-hour-exceptions/"
                                element={<BusinessHourExceptions />}
                            />
                            <Route
                                path="/business-closures/"
                                element={<BusinessClosures />}
                            />
                            <Route
                                path="/services"
                                element={<ServiceManagement />}
                            />
                            <Route
                                path="/leagues"
                                element={<LeagueManagement />}
                            />
                            <Route
                                path="/leagues/:leagueId/players-print"
                                element={<LeaguePlayersPrint />}
                            />
                            <Route
                                path="/league-payments"
                                element={<LeaguePayments />}
                            />
                            <Route
                                path="/league-scores"
                                element={<LeagueScoresAdmin />}
                            />
                        </Route>

                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/customer-login" element={<OtpLoginPage />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password/:token" element={<ResetPassword />} />
                        <Route
                            path="/registration"
                            element={<TeamRegistrationForm />}
                        />
                        <Route path="/" element={<BookingPage />} />
                        <Route path="/cancel/:guid" element={<CancelPage />} />
                        <Route path="/switch/:guid" element={<SwitchBookingPage />} />
                        <Route path="/league/:guid/register" element={<LeagueRegistration />} />
                        <Route path="/league/:leagueId/schedule" element={<LeagueSchedule />} />
                        <Route path="/league/:leagueId/scores" element={<LeagueScores />} />
                        <Route path="/league/:leagueId/upcoming" element={<UpcomingSchedule />} />
                        <Route path="/league/:leagueId/team-score" element={<LeagueTeamScore />} />
                        <Route path="/league/upcoming" element={<UpcomingSchedule />} />
                    </Routes>
                </BrowserRouter>
            </UserProvider>
        );
    }
}

export default App;
